import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/yaSplit.svg';

export const IconYaSplit = createIconComponent(Icon);
